import {
    GET_SUSPICION_DASHBOARD,
    GET_SUSPICION_MEMBERS,
} from '../../modules/constants';

export const getSuspicionDashboard = payload => ({
    type: GET_SUSPICION_DASHBOARD,
    payload,
});

export const getSuspicionMembers = payload => ({
    type: GET_SUSPICION_MEMBERS,
    payload,
});
